import React, { useEffect } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Container, toaster } from 'nallian-shared-ui/lib/components';
import { FullPageLoader } from 'nallian-shared-ui/lib/modules';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import keys from 'lodash/keys';
import withTheme from 'nallian-shared-ui/lib/hoc/withTheme';
import appsettings from 'nallian-shared-ui/lib/config/appsettings';
import useFavicon from 'nallian-shared-ui/lib/hooks/useFavicon';
import { GetTheme, GetThemeTag } from 'nallian-shared-ui/lib/selectors';
import { withTranslation } from 'react-i18next';
import translations from '../../../app/config/translations';

const Page = styled.div`
  min-height: 100vh;
  padding-top: 15vh;
  padding-bottom: 2rem;
  background: ${props => props.theme.landingPageBg} no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
`;

const Logo = styled.img`
  max-height: 200px;
  padding-bottom: 25px;
`;

const BasicLayout = props => {
  const { theme, t, i18n, children, themeTag } = props;

  const logoSrc = `${appsettings.azureCdnUri}/${themeTag}/react_gui/applogo.png`;

  useFavicon();

  useEffect(() => {
    if (i18n.languages && translations) {
      i18n.languages.forEach(language => {
        if (translations[language] && !i18n.hasResourceBundle(language, 'app')) {
          i18n.addResources(language, 'app', translations[language]);
        }
      });
    }
  }, [i18n]);

  return (
    <>
      {themeTag && keys(theme).length > 0 ? (
        <ThemeProvider theme={theme}>
          <Page>
            <Container textAlign="center" fluid>
              <Logo src={logoSrc} alt="logo" />
            </Container>
            {children}
          </Page>
          <toaster.Component preventDuplicates progressBar />
        </ThemeProvider>
      ) : (
        <FullPageLoader active content={t('loadingApplication')} />
      )}
    </>
  );
};

BasicLayout.propTypes = {
  children: PropTypes.node.isRequired,
  t: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired,
  themeTag: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  theme: GetTheme(state),
  themeTag: GetThemeTag(state),
});

export default compose(withTranslation('shared'), withTheme, connect(mapStateToProps))(BasicLayout);
